<template>
    <div class="about_item">
        <div class="about_item__head">
            {{ getTranslatedText(CT_PICK_3.TITLE_GAME) }}
        </div>
        <div class="about_item__content">
            <div class="about_item__content__table">
                <div class="about_item__content__table__item scroll">
                    <table class="table table-winnings-pick3">
                        <thead>
                            <tr>
                                <th scope="col">
                                    {{ getTranslatedText('Type de pari') }}
                                </th>
                                <th scope="col">
                                    {{ getTranslatedText('player selection') }}
                                </th>
                                <th scope="col">
                                    {{ getTranslatedText('winning condition') }}
                                </th>
                                <th scope="col">
                                    {{
                                        getTranslatedText('wager [currency]', {
                                            currency: this.$store.state.userInfo.gamev3.currency_code,
                                        })
                                    }}
                                </th>
                                <th scope="col">
                                    {{ getTranslatedText('multiplier') }}
                                </th>
                                <th scope="col">
                                    {{
                                        getTranslatedText('winnings [currency]', {
                                            currency: this.$store.state.userInfo.gamev3.currency_code,
                                        })
                                    }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in CT_PICKS3_DATA_ABOUT" :key="index">
                                <td>
                                    {{ getTranslatedText(item.betType) }}
                                </td>
                                <td>
                                    {{
                                        getTranslatedText(item.playerSelection, {
                                            digits: item.playerValueDigits,
                                            repetition: item.playerValueRepetition,
                                        })
                                    }}
                                </td>
                                <td>
                                    {{
                                        getTranslatedText(item.winningCondition, {
                                            count: item.winningCount,
                                        })
                                    }}
                                </td>
                                <td>
                                    {{ renderPrice(item.wager) }}
                                </td>
                                <td>{{ item.multiplier }} x</td>
                                <td>
                                    {{ renderPrice(item.winnings) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'

import { CT_PICK_3 } from '@/constants/lotto'
import { CT_PICKS3_DATA_ABOUT } from '@/constants/abouts/pick3'
import { formatPrice } from '@/utils/utils'

export default {
    mixins: [languageMixins],
    data() {
        return {
            CT_PICK_3,
            CT_PICKS3_DATA_ABOUT,
        }
    },
    methods: {
        renderPrice(price) {
            return price == '' ? '' : formatPrice(price)
        },
    },
}
</script>
